import { useState } from 'react';
import { Box, IconButton, Popover, TextField, Tooltip, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import TuneIcon from '@mui/icons-material/Tune';

const PRESETS = [
  ['빨강', '#dc2626'], ['주황', '#ea580c'], ['노랑', '#ca8a04'],
  ['연두', '#65a30d'], ['초록', '#16a34a'], ['민트', '#14b8a6'],
  ['하늘색', '#38bdf8'], ['파랑', '#2563eb'], ['남보라', '#6366f1'],
  ['보라', '#a855f7'], ['분홍', '#ec4899'], ['회색', '#64748b'],
  ['진한 빨강', '#b91c1c'], ['진한 주황', '#c2410c'], ['진한 노랑', '#a16207'],
  ['진한 연두', '#4d7c0f'], ['진한 초록', '#166534'], ['청록', '#0f766e'],
  ['청색', '#0891b2'], ['진한 파랑', '#1e40af'], ['진한 남보라', '#4338ca'],
  ['진한 보라', '#7c3aed'], ['진한 분홍', '#be185d'], ['진한 회색', '#334155'],
];
const isHex = value => /^#[0-9a-f]{6}$/i.test(value || '');

export function RiskColorPicker({ label, value, fallback, disabled, onChange }) {
  const [anchor, setAnchor] = useState(null);
  const current = isHex(value) ? value : fallback;
  return <div className="step-zero-color-editor" role="group" aria-label={`${label} 색상`}>
    <div className="step-zero-color-presets">
      {PRESETS.map(([name, color]) => <Tooltip key={color} title={name}><span style={{ display: 'inline-flex' }}>
        <button type="button" className="step-zero-color-swatch" disabled={disabled}
          aria-label={`${label} ${name}`} aria-pressed={current?.toLowerCase() === color}
          style={{ backgroundColor: color }} onClick={() => onChange(color)}>
          {current?.toLowerCase() === color && <CheckIcon sx={{ fontSize: 16, filter: 'drop-shadow(0 1px 1px #000)' }} />}
        </button>
      </span></Tooltip>)}
    </div>
    <Tooltip title="기본 색상으로 복원"><span><IconButton size="small" disabled={disabled || !value}
      aria-label={`${label} 기본 색상으로 복원`} onClick={() => onChange(null)}><RestartAltIcon fontSize="small" /></IconButton></span></Tooltip>
    <Tooltip title="고급 색상 설정"><span><IconButton size="small" disabled={disabled}
      aria-label={`${label} 고급 색상 설정`} aria-expanded={Boolean(anchor)}
      onClick={event => setAnchor(event.currentTarget)}><TuneIcon fontSize="small" /></IconButton></span></Tooltip>
    <Popover open={Boolean(anchor)} anchorEl={anchor} onClose={() => setAnchor(null)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
      <Box role="dialog" aria-label={`${label} 고급 색상 설정`} sx={{ p: 2, width: 260, maxWidth: 'calc(100vw - 32px)', boxSizing: 'border-box' }}>
        <Typography sx={{ fontSize: 14, mb: 1.5 }}>{label} 색상</Typography>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
          <input type="color" disabled={disabled} aria-label={`${label} 사용자 지정 색상`}
            value={current} onChange={event => onChange(event.target.value)}
            style={{ width: 40, height: 40, padding: 2, border: '1px solid #d3d9df', borderRadius: 4, background: '#fff', flexShrink: 0, cursor: 'pointer' }} />
          <TextField fullWidth size="small" label="HEX" disabled={disabled} value={value || ''} placeholder={fallback}
            inputProps={{ maxLength: 7, 'aria-label': `${label} HEX 색상` }}
            error={Boolean(value && !isHex(value))} helperText={value && !isHex(value) ? '#RRGGBB 형식으로 입력하세요.' : ' '}
            onChange={event => onChange(event.target.value)} />
        </Box>
      </Box>
    </Popover>
  </div>;
}
